import { afterAnimationFrame } from '@prophecy/utils/dom';
import { usePersistentCallback } from '@prophecy/utils/react/hooks';
import { CodeBlockPlugin, CodeLinePlugin } from '@udecode/plate-code-block/react';
import { useEditorRef } from '@udecode/plate/react';
import { noop } from 'lodash-es';
import { Editor, Transforms } from 'slate';
import { ReactEditor } from 'slate-react';
import { tokens } from './tokens';
export function isCommentNodeEditorActive() {
    return document.activeElement?.matches(`.${tokens.classNames.slateEditor}`);
}
export function isInsideCodeBlock(editor) {
    return !!editor.api.above({
        match: { type: [CodeBlockPlugin.key, CodeLinePlugin.key] }
    });
}
export function useToolbarButtonClick(onClick) {
    const editor = useEditorRef();
    return usePersistentCallback(() => {
        if (isInsideCodeBlock(editor)) {
            return;
        }
        onClick();
    });
}
export function handleFormatKeyBinding({ editor, event, key }) {
    if ((event.metaKey || event.ctrlKey) && event.key === key && isInsideCodeBlock(editor)) {
        event.preventDefault();
    }
}
export function focusEditorAfterOperation(editor, operation = noop) {
    // Note: PlateEditor extends ReactEditor editor, so we can safely typecast for focus purpose
    const _editor = editor;
    if (!editor.selection) {
        ReactEditor.focus(_editor);
        return;
    }
    const currentPoint = editor.selection.focus || editor.selection.anchor;
    const focusRef = Editor.pointRef(_editor, currentPoint, {
        affinity: 'forward'
    });
    operation();
    const point = focusRef.unref();
    if (!point)
        return;
    afterAnimationFrame(() => {
        // place selection at the end
        Transforms.select(_editor, point);
        Transforms.collapse(_editor, { edge: 'end' });
        ReactEditor.focus(_editor);
    });
}
export const RICH_UX_EMBEDDING_PREFIX = 'data:prophecy';
export function isRichUXEmbedding(url) {
    return url.startsWith(RICH_UX_EMBEDDING_PREFIX);
}
export var RichUXEmbeddingDataType;
(function (RichUXEmbeddingDataType) {
    RichUXEmbeddingDataType["BASE64"] = "base64";
    RichUXEmbeddingDataType["JSON"] = "json";
})(RichUXEmbeddingDataType || (RichUXEmbeddingDataType = {}));
// Sample URL: ![](data:prophecy_json/{"type":"EmbeddingName","version":1,"properties":{...}})
export function parseRichUXEmbeddingUrl(url) {
    const [embeddingIdentifier, data] = url.split('/');
    const [, dataType] = embeddingIdentifier.split('_');
    let dataString;
    if (dataType === RichUXEmbeddingDataType.BASE64) {
        dataString = atob(data) ?? '{}';
    }
    else {
        dataString = decodeURIComponent(data) ?? '{}';
    }
    const parsedData = JSON.parse(dataString);
    return parsedData;
}
export var RichUxEmbeddingType;
(function (RichUxEmbeddingType) {
    RichUxEmbeddingType["Question"] = "Question";
    RichUxEmbeddingType["CopilotQuestion"] = "CopilotQuestion";
    RichUxEmbeddingType["Canvas"] = "Canvas";
})(RichUxEmbeddingType || (RichUxEmbeddingType = {}));
